import {Col, Container, Form, Row} from "react-bootstrap";
import React, {useContext, useState} from "react";
import useWindowDimensions from "hooks/Dimensions";
import {ActionPanelContext} from "context/action";
import {API_CALL_ERR_MSG} from "utils/ConstantsMsg";
import {ToastContext} from "context/Toast";

export default function WireRejectModal(props) {

    const {setShowReject, setShow, gridApi} = props
    const {isDesktop, isMobile} = useWindowDimensions();
    const {handleReject, isValidRejecter} = useContext(ActionPanelContext);
    const [comment, setComment] = useState('');
    const [rejecting, setRejecting] = useState(false);
    const {error, success, alert} = useContext(ToastContext);

    let confirmDeleteBtnClassName = "btn btn-block ";
    confirmDeleteBtnClassName += isDesktop ? 'td-btn-primary-light' : 'td-btn-red ';

    const handleOnChange = (param) => {
        setComment(param.target.value)
    }

    const handleOnRejectClicked = () => {

        if(gridApi.getSelectedRows().length == 0){
            alert("Select an item to reject")
            setRejecting(true)
            return
        }

        const onSuccess = () => {
            setRejecting(true);
            setShowReject(false)
            setShow(false);
            success("Item/s rejected successfully")

        }

        const onError = (err) => {
            let errMsg = API_CALL_ERR_MSG
            if (err.response.status == 409)
                errMsg = err.response.data
            else if(err.response.status == 500)
                errMsg = err.response.data
            error(errMsg)

            setRejecting(true);
            setShow(true);
            setShowReject(true);
        }

        handleReject(comment, onSuccess, onError);
    }
    const getRestrictedItems = () => {
        return gridApi.getSelectedRows().filter(row => !row.isValidRejecter).map((row, i) => getRowData(row, i))
    }

    const getRowData = (row, i) => {
        return<>
            <span>{i+1}) Template:{row.templateName}, Manager:{row.managerNameShort}, Account:{row.cdClient}, Status:{row.status} </span>
        </>
    }

    return (<>
        {!isValidRejecter ?
            <Container fluid className={"my-3 my-md-0"}>
                <Row>
                    <Col md={12}>
                        <h4 style={{textAlign: isDesktop?'left':'center'}}>The following items cannot be rejected:</h4>
                    </Col>
                    <Col>
                        {getRestrictedItems()}
                    </Col>
                </Row>
            </Container>
        :
        <Container fluid className={"my-3 my-md-0"}>
            <Row>
                <Col md={12}>
                    <h4 style={{textAlign: isDesktop?'left':'center'}}>Are you sure you want to reject this?</h4><br/>
                </Col>
            </Row>
            <Row>
                <Col md={12} className='pb-2'>
                    <Form.Group controlId="comment">
                        <Form.Label className="filter-input-label pb-2">Add Comments</Form.Label>
                        <Form.Control as='textarea' rows={5} placeholder="Leave a comment" disabled={rejecting}
                                      name={"comment"} value={comment}
                                      onChange={handleOnChange}/>
                    </Form.Group>
                </Col>
            </Row>
            <Row className={"justify-content-end"}>
                <Col md={4} xs={12} sm={12}>
                    <button  disabled={rejecting} className={confirmDeleteBtnClassName} href="#" onClick={handleOnRejectClicked}>Reject
                    </button>
                </Col>
                <Col md={4} xs={12} className='md-pr-0 d-md-block'>
                    <button disabled={rejecting} className='btn btn-block td-btn-secondary-clear' href="#" onClick={() => {
                        setShow(false);
                        setShowReject(false);
                    }}>Cancel
                    </button>
                </Col>
            </Row>
        </Container>}
    </>)
}

